// extracted by mini-css-extract-plugin
export default {"navItem":"NavBarItem_navItem__BXcmb","active":"NavBarItem_active__KESwB","icon":"NavBarItem_icon__dpUrv","title":"NavBarItem_title__armQw","count":"NavBarItem_count__X3uOk"};